/**************************************************
 * Nombre:       Tarjeta_Porque
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Porque = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 3, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'80%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 9, sm: 12, md: 10}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 18, fontWeight: 600}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                        {item.descripcion}
                    </Typography>
                </Grid>


            </Grid>
        </Grid>
    )

}
export default Tarjeta_Porque